import React from "react";
import {Box, Stack, Button, Card, CardContent, CardHeader, Typography, Chip} from "@mui/material";
import AlertMessage from "../../../Common/Alert/AlertMessage";

import AutoGraphIcon from '@mui/icons-material/AutoGraph';

function ActivityPDPContent ({activity, onClick}) {

    let alert = {
        active: false,
        severity: '',
        message: ''
    };

    return (

        <Card className="card">
            <CardHeader
                disableTypography={true}
                title={<Typography component="h2" className="card-header-title">Personal development</Typography>}
                subheader={
                    <Typography component="span" className="card-header-subtitle">
                        Link this activity to a development need
                    </Typography>
                }
                action={
                    <Stack
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={2}
                        sx={{padding: '8px'}}
                    >
                        {activity.canUpdate && (
                            <Button
                                variant="contained"
                                color="neutral"
                                disableElevation={true}
                                aria-label="Link to development needs"
                                onClick={onClick}
                                startIcon={<AutoGraphIcon />}
                            >Link
                            </Button>
                        )}
                    </Stack>
                }
            />
            <CardContent>
                <Box className="card-content">
                    {activity?.developmentNeeds?.length > 0  && (
                        <Box className="card-content">
                            { activity.developmentNeeds.map((developmentNeed, index) => (
                                <Chip
                                    icon={<AutoGraphIcon fontSize={"small"}  />}
                                    key={developmentNeed.id}
                                    label={developmentNeed.title}
                                    className="chip"
                                    variant="outlined"
                                    color="primary"
                                />
                            ))}
                        </Box>
                    )}
                </Box>
            </CardContent>

            {alert.active && (
                <CardContent>
                    <Box className="card-content">
                        <AlertMessage severity={alert.severity} message={alert.message} />
                    </Box>
                </CardContent>
            )}

        </Card>

    );
}

export default ActivityPDPContent;